<template>
  <div class="blog-posts-page posts">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h1 class="w-full mr-2">New review for {{ $route.params.pageSlug }}</h1>
    </div>
    <div>
      <!-- <div class="pointer mr-4 border-dark" @click="setDefaultUser()">
        <strong>Marko</strong>
      </div> -->
      <div class="row mb-3">
        <div class="input-group col-md-6">
          <input
            class="form-control"
            type="email"
            v-model="newReview.email"
            placeholder="Email"
          />
        </div>
        <div class="input-group col-md-6">
          <input
            class="form-control"
            type="text"
            v-model="newReview.name"
            placeholder="Name"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="input-group col-md-6">
          <input
            class="form-control"
            type="text"
            v-model="newReview.title"
            placeholder="Title"
          />
        </div>
        <div class="input-group col-md-6">
          <input
            class="form-control"
            type="number"
            max="5"
            min="1"
            v-model="newReview.rating"
            placeholder="Rating (1-5)"
          />
        </div>
      </div>
      <div class="input-group mb-3">
        <textarea
          class="form-control"
          type="text"
          v-model="newReview.review"
          placeholder="Review"
          rows="3"
        />
      </div>
      <button
        :disabled="areFieldsEmpty"
        class="btn btn-primary ml-auto d-flex align-items-center"
        @click.prevent="addReview()"
      >
        <b>Save</b>
      </button>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "NewReview",
  data: () => ({
    newReview: {
      title: "",
      rating: "",
      review: "",
      name: "",
      email: "",
      status: false,
      page: ""
    }
  }),
  computed: {
    areFieldsEmpty() {
      return (
        this.newReview.title === "" ||
        this.newReview.name === "" ||
        this.newReview.email === "" ||
        this.newReview.review === "" ||
        this.newReview.rating === ""
      );
    }
  },
  methods: {
    // setDefaultUser() {
    //   this.newReview.name = "Marko Savić";
    //   this.newReview.email = "marcodentaltourism@gmail.com";
    // },
    addReview() {
      this.newReview.page = this.$route.params.pageSlug;
      axios
        .post("/reviews", { ...this.newReview })
        .then(() => {
          this.getReviews();
          this.$vToastify.success("Review added.");
          this.newReview.review = "";
          this.newReview.title = "";
          this.newReview.name = "";
          this.newReview.email = "";
          this.newReview.rating = "";
        })
        .catch(error => {
          console.log(error);
          this.$vToastify.error(error.message, "Error");
        });
    }
  }
};
</script>
<style scoped>
@media (max-width: 575.98px) {
  .input-group {
    margin: 8px 0;
  }
}
</style>
